export enum PlanRecurrenceFrequencyTypes {
    monthly = 'monthly',
    annual = 'annual',
}
